
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 10","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 8.536c0 .542.438.964 1 .964h10c.542 0 1-.422 1-.964V5H0v3.536zM4 7.17c0-.12.104-.241.25-.241h2.833c.125 0 .25.12.25.24v.804c0 .14-.125.241-.25.241H4.25c-.146 0-.25-.1-.25-.24V7.17zm-2.667 0c0-.12.105-.241.25-.241h1.5c.125 0 .25.12.25.24v.804c0 .14-.125.241-.25.241h-1.5c-.145 0-.25-.1-.25-.24V7.17zM12 1.464C12 .942 11.542.5 11 .5H1c-.563 0-1 .442-1 .964v.965h12v-.965z","fill":"currentColor"}})])
          )
        }
      }
    